import { BrowserRouter as Router, Routes, Route, Outlet } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { OpenAIProvider } from './contexts/OpenAIContext';
import { GeminiProvider } from './contexts/GeminiContext';
import { ParameterBuilderProvider } from './contexts/ParameterBuilder';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';
import VIPRoute from './components/VIPRoute';
import Login from './pages/Login';
import Register from './pages/Register';
import Radar from './pages/Radar';
import Dashboard from './pages/Dashboard';
import Generator from './pages/Generator';
import Profile from './pages/Profile';
import Admin from './pages/Admin';
import History from './pages/History'
import Popular from './pages/Popular'
import VIP from './pages/VIP'
import Payment from './pages/Payment'
import PaymentSuccess from './pages/PaymentSuccess'
import Header from './components/Header'
import OneClick from './pages/OneClick'
import PublicRoute from './components/PublicRoute'
import Landing from './pages/Landing'
import { HelmetProvider } from 'react-helmet-async'
import Tools from './pages/Tools'
import ToolsDetail from './pages/ToolsDetail'
import AdminPayment from './pages/AdminPayment'
import AdminMember from './pages/AdminMember'
import AdminTools from './pages/AdminTools'
import VIPGen from './pages/VIPGen'
import Report from './pages/Report'
import ResetPassword from './pages/ResetPassword'
import Tutorial from './pages/Tutorial'
import ConceptKeyword from './pages/conceptKeyword'
import ReadyPrompt from './pages/ReadyPrompt'

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <OpenAIProvider>
          <GeminiProvider>
            <ParameterBuilderProvider>
            <Router>
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route element={<>
                  <Header />
                  <Outlet />
                </>}>
                  <Route path="/dashboard" element={
                    <PublicRoute requireAuth={true}>
                      <Dashboard />
                    </PublicRoute>
                  } />
                  <Route path="/generator" element={<PrivateRoute><Generator /></PrivateRoute>} />
                  <Route path="/vipgen" element={<PrivateRoute><VIPGen /></PrivateRoute>} />
                  <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
                  <Route path="/radar" element={<PrivateRoute><Radar /></PrivateRoute>} />
                  <Route path="/tutorial" element={<PrivateRoute><Tutorial /></PrivateRoute>} />
                  <Route path="/admin" element={<AdminRoute><Admin /></AdminRoute>} />
                  <Route path="/admin/payment" element={<AdminRoute><AdminPayment /></AdminRoute>} />
                  <Route path="/admin/member" element={<AdminRoute><AdminMember /></AdminRoute>} />
                  <Route path="/admin/tools" element={<AdminRoute><AdminTools /></AdminRoute>} />
                  <Route path="/report" element={<AdminRoute><Report /></AdminRoute>} />
                  <Route path="/ready-prompt" element={<VIPRoute><ReadyPrompt /></VIPRoute>} />
                  <Route path="/history" element={<PrivateRoute><History /></PrivateRoute>} />
                  <Route path="/popular" element={<PrivateRoute><Popular /></PrivateRoute>} />
                  <Route path="/vip" element={<PrivateRoute><VIP /></PrivateRoute>} />
                  <Route path="/payment" element={<PrivateRoute><Payment /></PrivateRoute>} />
                  <Route path="/payment-success" element={<PrivateRoute><PaymentSuccess /></PrivateRoute>} />
                  <Route path="/one-click" element={<PrivateRoute><OneClick /></PrivateRoute>} />
                  <Route path="/conceptKeyword" element={<PrivateRoute><ConceptKeyword /></PrivateRoute>} />
                  <Route path="/tools" element={
                    <PrivateRoute>
                      <Tools />
                    </PrivateRoute>
                  } />
                  <Route path="/tools/:id" element={
                    <PrivateRoute>
                      <ToolsDetail />
                    </PrivateRoute>
                  } />
                </Route>
              </Routes>
            </Router>
            </ParameterBuilderProvider>
          </GeminiProvider>
        </OpenAIProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
